import { hideLoading, showLoading } from "../slices/loadingBarSlice";

export default function loadingBarMiddleware() {
  return ({ dispatch }) =>
    (next) =>
    (action) => {
      if (action.type) {
        if (action.type.toLowerCase().includes("request")) {
          dispatch(showLoading());
        } else if (
          action.type.toLowerCase().includes("success") ||
          action.type.toLowerCase().includes("fail") ||
          action.type.toLowerCase().includes("cancel")
        ) {
          dispatch(hideLoading());
        }
      }
      return next(action);
    };
}
